import React from 'react'
import { useHistory } from 'react-router'
import * as S from './styled'

export const BackButton = () => {
  const history = useHistory()

  return <S.Button onClick={() => history.push(`/documents`)}>Tillbaka</S.Button>
}

export default BackButton
